import { Injectable } from '@angular/core';
import { Http, Response, Headers, URLSearchParams, RequestOptions, RequestMethod } from '@angular/http';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { map } from 'rxjs/operators';
import * as $ from 'jquery';
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, ActivatedRoute } from '@angular/router';
import * as _ from 'underscore';
import { Subject } from 'rxjs/Subject';
import { BehaviorSubject } from 'rxjs';
import { BackgroundCheckService } from '../../get-my-background-check/background-shared/services/backgroundCheck.service';
import { debug } from 'util';




@Injectable()
export class CommonService implements CanActivate {
    public OrderReportToken: string = '';
    public SenderEmailId = '';
    public IsVerifyRecord: boolean = false;
    public DataSource: any;
    public IsRoleJobCandidate = false;
    public IsRoleEmplAndEduct = false;
    public IsRoleVerifier = false;
    public IsErrorMsg = false;
    public IsAccountSetting = false;
    public ExpirationYear = [];
    public ExpirationMonth = [];
    public HideSideNav: boolean = false;
    public GotToPageInDifferentCaseOfArray = [];
    public InWhichPageWeGo: string = ""
    public IsPackageContainEmpEduAndProService = false
    public IsNewServicesAddInPackage: boolean = false;
    public SelectTabMatPannel = 1;
    public PendingPage = 'NewUser';
    public IsSignatureSaved = false;

    constructor(private Router: Router, private Route: ActivatedRoute, private _BackgroundCheckService: BackgroundCheckService) {
        var year = (new Date()).getFullYear();
        for (var i = 0; i < 20; i++) {
            this.ExpirationYear.push(year + i);
        }

        for (var i = 1; i <= 12; i++) {
            this.ExpirationMonth.push(i);
        }
    }

    AddclassInOrderTabs(index) {
        const basSelection = $('.AddTabSucessClass').children(0).children(3).children().children(0).children(0);

        switch (index) {
            case 1:
                {
                    basSelection.first().addClass('IsTabSucess');
                    break;
                }
            case 2:
                {
                    basSelection.first().next().addClass('IsTabSucess');
                    break;
                }
            case 3:
                {
                    basSelection.first().next().next().addClass('IsTabSucess');
                    break;
                }
            case 4:
                {
                    basSelection.first().next().next().next().addClass('IsTabSucess');
                    break;
                }
        }

    }


    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        if (localStorage.getItem('AccessToken') != null) {
            // logged in so return true
            return true

        }

        this.OrderReportToken = route.queryParams['report-token'];
        this.SenderEmailId = route.queryParams['id'];

        if (localStorage.getItem('AccessToken') == null) {
            if (this.OrderReportToken !== undefined && this.SenderEmailId !== undefined) {
                return true;
            } else {
                this.Router.navigateByUrl('/login');
            }
        }

        // not logged in so redirect to login page with the return url
        return false;



    }

    CheckPackageCheckTheContainService(signature) {
        this._BackgroundCheckService.GetPackageRefernceId(parseInt(atob(localStorage.getItem("PackageId")))).
            subscribe(res => this.GetPackageIDSucess(res), res => this.GetPackageIDError(res));
        let ArrayOfService = JSON.parse(localStorage.getItem('OrderSummaryDetails'));
        let Services = ArrayOfService[0].Services;
        var i;
        for (i = 0; i < Services.length;) {
            let ServiceLoop = Services[i];

            if (ServiceLoop.ServiceMasterId === 10) {
                if (ServiceLoop.IsCompletedDetails === null || ServiceLoop.IsCompletedDetails == false) {
                    this.Router.navigate(['/background-login/country-check']);
                    return true;
                }
            }
            i++;
        }
        if (signature == null) {
            // localStorage.setItem("IsNewOrder", "Yes")
            this.Router.navigate(['/background-login/signature']);
        } else {
            this.Router.navigate(['/background-login/dashboard'])
        }
        return false;
    }

    GetPackageIDSucess(res) {
        localStorage.setItem('ReferenceId', btoa(res.toString()));
    }

    GetPackageIDError(res) { }

    IsPackageContainEmployerEducationAndProfessionService(Services) {
        for (let index = 0; index < Services.length;) {
            if (Services[index].ServiceMasterId == 5 || Services[index].ServiceMasterId == 6 || Services[index].ServiceMasterId == 36) {
                if ((Services[index].IsCompletedDetails == false || Services[index].IsCompletedDetails == null) && (Services[index].WorkPastId == "" || Services[index].WorkPastId == null)) {
                    this.IsPackageContainEmpEduAndProService = true;
                    this.Router.navigate(['/background-login/employement-education-professional-check']);
                    return true;
                }
            }
            index++
        }
    }

    IsPackageContainCriminalCheckService(Services) {
        for (let index = 0; index < Services.length;) {
            if (Services[index].ServiceMasterId == 10) {
                if (Services[index].IsCompletedDetails == null || Services[index].IsCompletedDetails == false) {
                    this.Router.navigate(['/background-login/country-check']);
                    return true
                }
            }
            index++
        }
    }

    getPager(totalItems: number, currentPage: number = 1, pageSize: number = 10) {
        // calculate total pages
        const totalPages = Math.ceil(totalItems / pageSize);

        let startPage: number, endPage: number;

        if (totalPages <= 5) {
            startPage = 1;
            endPage = totalPages;
        } else {
            if (currentPage <= 3) {
                startPage = 1;
                endPage = 5;
            } else if (currentPage + 1 >= totalPages) {
                startPage = totalPages - 4;
                endPage = totalPages;
            } else {
                startPage = currentPage - 2;
                endPage = currentPage + 2;
            }
        }

        // calculate start and end item indexes
        const startIndex = (currentPage - 1) * pageSize;
        const endIndex = Math.min(startIndex + pageSize - 1, totalItems - 1);

        // create an array of pages to ng-repeat in the pager control
        const pages = _.range(startPage, endPage + 1);

        // return object with all pager properties required by the view
        return {
            totalItems: totalItems,
            currentPage: currentPage,
            pageSize: pageSize,
            totalPages: totalPages,
            startPage: startPage,
            endPage: endPage,
            startIndex: startIndex,
            endIndex: endIndex,
            pages: pages
        };
    }

    GetPhoneNumberWithCountryCode(Value) {
        if (typeof Value === 'object') {
            let ContactNumber: any;
            ContactNumber = Value;
            return ContactNumber.internationalNumber;

        }
        return Value;
    }



};